// extracted by mini-css-extract-plugin
export default {"PostDetailRight__searchPanel":"ql_a bho_sw bho_kx bho_ky","PostDetailRight__brandDaysPosts":"ql_b bho_sw bho_kx bho_ky"};